import { useEffect, useRef, useState } from 'react';
import Calendar from 'react-calendar';
import { Button, ButtonGroup, ButtonProps, Menu, styled, TextField } from '@mui/material';
import { purple } from '@mui/material/colors';
import block from 'bem-cn';
import dayjs from 'dayjs';

import MainPageStore from 'stores/MainPageStore';

import { selectDate } from './selectDate';

import './CalendarWrap.scss';
import 'react-calendar/dist/Calendar.css';

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  'color': theme.palette.getContrastText(purple[500]),
  'backgroundColor': purple[500],
  '&:hover': {
    backgroundColor: purple[700],
  },
}));

const cnCalendar = block('Calendar');

interface CalendarProps {
  page: string;
}

function CalendarWrap({ page }: CalendarProps) {
  const [value, onChange] = useState<any>(new Date());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [type, setTYpe] = useState<string>('ДЕНЬ');
  const [inputValue, setInputValue] = useState<string>('Выберите дату');
  const [responseValue, setResponseValue] = useState<any>(value);
  const open = Boolean(anchorEl);
  const calendarRef = useRef(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setTYpe(event.currentTarget.innerText);
    if(calendarRef.current){
      setAnchorEl(calendarRef.current)
    }
  };

  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if(value.view){
      console.log(value)
       onChange((e)=>{
       return e.value = e.activeStartDate
      })
    }else{
      selectDate(type,value,setInputValue,setResponseValue);
      //setAnchorEl(null);
    }
  }, [type, value]);

  useEffect(() => {
    if (!(page == 'price')) {
        MainPageStore.setPageData(
          page,
          MainPageStore.departmentSelect?.map((el) => {
            return el.label;
          }),
          responseValue[0],
          responseValue[1],
          responseValue[2],
          responseValue[3],
          MainPageStore.paytypeSelect?.map((el) => {
            return el.label;
          }),
          MainPageStore.bedtypeSelect?.map((el) => {
            return el.label;
          }),
          MainPageStore.roomClassTypeSelect?.map((el) => {
            return el.label;
          }),
          MainPageStore.roomTypeSelect?.map((el) => {
            return el.label;
          }),
          MainPageStore.buildingTypeSelect?.map((el) => {
            return el.label;
          }),
          MainPageStore.filtersInput?.map((el) => {
            return el.label;
          }),
          MainPageStore.mp_profile_filter?.map((el) => {
            return el.label;
          }),
          MainPageStore.smp_ksg_filter?.map((el) => {
            return el.value;
          }),
          MainPageStore.diagnosis_main_filter?.map((el) => {
            return el.value;
          }),
          MainPageStore.fin_source_filter?.map((el) => {
            return el.value;
          }),
          MainPageStore.mp_name_filter?.map((el) => {
            return el.value;
          }),
        );
    } else {
      !!MainPageStore.departmentSelect.length &&
      MainPageStore.setPageData(
        page,
        MainPageStore.departmentSelect?.map((el) => {
          return el.label;
        }),
        responseValue[0],
        responseValue[1],
        responseValue[2],
        responseValue[3],
        MainPageStore.paytypeSelect?.map((el) => {
          return el.label;
        }),
        MainPageStore.bedtypeSelect?.map((el) => {
          return el.label;
        }),
        MainPageStore.roomClassTypeSelect?.map((el) => {
          return el.label;
        }),
        MainPageStore.roomTypeSelect?.map((el) => {
          return el.label;
        }),
        MainPageStore.buildingTypeSelect?.map((el) => {
          return el.label;
        }),
        MainPageStore.filtersInput?.map((el) => {
          return el.label;
        }),
        MainPageStore.mp_profile_filter?.map((el) => {
          return el.label;
        }),
        MainPageStore.smp_ksg_filter?.map((el) => {
          return el.value;
        }),
        MainPageStore.diagnosis_main_filter?.map((el) => {
          return el.value;
        }),
        MainPageStore.fin_source_filter?.map((el) => {
          return el.value;
        }),
        MainPageStore.mp_name_filter?.map((el) => {
          return el.value;
        }),
      );
    }

    MainPageStore.setDates(responseValue);
  }, [responseValue]);

 

  return (
    <div className={cnCalendar()}>
      <TextField
        id="outlined-helperText"
        label={
          type === 'ПЕРИОД' ? 'Начальная дата' : type?.split('')[0] + type?.slice(1).toLowerCase()
        }
        defaultValue={dayjs(value[0]?.toDateString() ?? value).format('YYYY-MM-DD')}
        value={inputValue}
        size="small"
        color="secondary"
        focused
        sx={{ marginRight: '1vw' }}
        onClick={handleOpen}
        ref={calendarRef}
      />
      {type === 'ПЕРИОД' && (
        <TextField
          id="outlined-helperText"
          label="Дата окончания"
          defaultValue={dayjs(value[1]?.toDateString() ?? value).format('YYYY-MM-DD')}
          value={dayjs(value[1]?.toDateString() ?? value).format('YYYY-MM-DD')}
          size="small"
          color="secondary"
          focused
          sx={{ marginRight: '1vw' }}
          onClick={handleOpen}
        />
      )}
      <ButtonGroup>
        <ColorButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className='btnCalendar'
        >
          день
        </ColorButton>
        <ColorButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className='btnCalendar'
        >
          месяц
        </ColorButton>
        <ColorButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className='btnCalendar'
        >
          год
        </ColorButton>
        <ColorButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          className='btnCalendar'
        >
          Период
        </ColorButton>
      </ButtonGroup>
      <Menu
        id="basic-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Calendar
          selectRange={type === 'ПЕРИОД' ? true : undefined}
          view={type === 'ГОД' ? 'decade' : type === 'МЕСЯЦ' ? 'year' : undefined}
          onViewChange={onChange}
          maxDetail={type === 'МЕСЯЦ' ? 'year' : type === 'ГОД' ? 'decade' : 'month'}
          onChange={onChange}
          value={value}
        />
      </Menu>
    </div>
  );
}
export default CalendarWrap;
